<ion-content>
  <ion-grid class="max-w-1400px">
    <ion-row>
      <ion-col>
        <div class="logo">
          <a href="http://www.radimdienst.de">
            <img
              *ngIf="showBusinessLogo"
              src="assets/imgs/color_logo.png"
              alt="Business Logo"
            />
            <img
              *ngIf="!showBusinessLogo"
              src="assets/imgs/logo-1.png"
              alt="Default Logo"
            />
          </a>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col
        class="ion-margin-start ion-margin-end"
        style="padding-bottom: 8px"
      >
        <h1
          class="text-center"
          style="margin-bottom: 4px; color: var(--rd-text-primary)"
        >
          Errechnen Sie den Vorteil für Ihr
          <span style="color: var(--radim-dienst-green)">Dienstrad</span>
        </h1>
        <p
          class="text-center"
          style="
            color: #111827;
            font-size: 17px;
            margin-top: 4px;
            font-weight: 600;
          "
        >
          Berechnen Sie Ihre individuelle Ersparnis beim Dienstrad-Leasing
        </p>
      </ion-col>
    </ion-row>
    <ion-row class="justify-content-center">
      <ion-col size="12" size-lg="6">
        <div class="content-spanner border-box bg-light-dark">
          <ion-grid>
            <br />
            <ion-row class="pt-2" *ngIf="isZuschussModellEligible">
              <ion-col class="py-0">
                <ion-item lines="inset">
                  <ion-select
                    label="Zuschussmodell / Fairbetrag"
                    labelPlacement="floating"
                    interface="popover"
                    [ngModel]="dSS.zuschussModellPercent"
                    (ionChange)="onZuschussModellChange($event.detail.value)"
                  >
                    <ion-select-option
                      *ngFor="let opt of zuschussModelOptions"
                      [value]="opt.value"
                    >
                      {{ opt.label }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row class="pt-2">
              <ion-col class="py-0 position-relative">
                <ion-item lines="inset">
                  <ion-label position="stacked">
                    <div class="info-label">
                      <span>Dienststellencode / Leasingcode</span>
                      <ion-icon
                        class="info-icon"
                        name="information-circle-outline"
                        (click)="dSS.toggleInfo('A')"
                      ></ion-icon>
                    </div>
                  </ion-label>
                  <ion-input
                    #myInput
                    type="text"
                    style="text-transform: capitalize"
                    [(ngModel)]="inputValue"
                    (focusout)="onInputChange()"
                    placeholder="Ohne Dienststellencode"
                    [autofocus]="true"
                  >
                  </ion-input>
                </ion-item>
                <div *ngIf="dSS.currInfo === 'A'" class="info-box">
                  <p class="info-text">
                    Den Dienststellen-Code finden Sie auf Ihrem
                    Informationsflyer zum Dienstrad-Leasing.
                  </p>
                </div>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.isLimbachLeasing() && dSS.isLimbachAcknowledged()"
            >
              <ion-col class="py-0 position-relative">
                <div class="limbach-fade-in">
                  <ion-item lines="inset">
                    <ion-label position="stacked">
                      <div class="info-label">
                        <span>Leasingmodell</span>
                        <ion-icon
                          class="info-icon"
                          name="information-circle-outline"
                          (click)="dSS.toggleInfo('LIMBACH')"
                        ></ion-icon>
                      </div>
                    </ion-label>
                    <ion-select
                      interface="popover"
                      [(ngModel)]="dSS.limbachModel"
                      (ionChange)="dSS.inputChanged.next(true)"
                    >
                      <ion-select-option
                        *ngFor="let option of dSS.limbachModelOptions"
                        [value]="option.value"
                      >
                        {{ option.display }}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </div>
                <div
                  *ngIf="dSS.currInfo === 'LIMBACH'"
                  class="info-box info-box--limbach"
                >
                  <p class="info-text" *ngIf="dSS.getLimbachGroup() === 'stadt'">
                    <strong>Traditionell (Lio-0526):</strong> Leasingrate und
                    Übernahmepreis stehen in einem ausgewogenen Verhältnis.<br /><br />
                    <strong>Niedrige Rate (Lnr-0526):</strong> Niedrigere
                    monatliche Leasingrate, dafür ein höherer Übernahmepreis am
                    Ende der Laufzeit. Die Gesamtersparnis fällt in der Regel
                    geringer aus als beim traditionellen Modell.<br /><br />
                    <strong>Maximale Ersparnis (Lme-0526):</strong> Höhere
                    monatliche Leasingrate, dafür ein niedrigerer
                    Übernahmepreis. Dadurch kann insgesamt eine höhere
                    Ersparnis erzielt werden.
                  </p>
                  <p class="info-text" *ngIf="dSS.getLimbachGroup() === 'baeder'">
                    <strong>Traditionell (Blo-0526):</strong> Leasingrate und
                    Übernahmepreis stehen in einem ausgewogenen Verhältnis.<br /><br />
                    <strong>Niedrige Rate (Bnr-0526):</strong> Niedrigere
                    monatliche Leasingrate, dafür ein höherer Übernahmepreis am
                    Ende der Laufzeit. Die Gesamtersparnis fällt in der Regel
                    geringer aus als beim traditionellen Modell.<br /><br />
                    <strong>Maximale Ersparnis (Bme-0526):</strong> Höhere
                    monatliche Leasingrate, dafür ein niedrigerer
                    Übernahmepreis. Dadurch kann insgesamt eine höhere
                    Ersparnis erzielt werden.
                  </p>
                </div>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Leasingfaktor"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="dSS.dienststelle.leasingfaktor"
                    (ngModelChange)="berechnen()"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Übernahmeprozent"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="dSS.dienststelle.uebernahmeprozent"
                    (ngModelChange)="berechnen()"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Leasingrate"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="outLeasingrate"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Versicherungsrate"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="outVersAN1"
                    (ionInput)="userEditedVersicherung = true"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="
              dSS.dsCode === 'Kal-radimdienst' ||
              dSS.dsCode === 'Kal-Radimdienst' ||
              dSS.dsCode === 'kal-radimdienst'
            "
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Inspektionsrate"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="outInspektion"
                    (ionInput)="userEditedInspektion = true"
                  ></ion-input>
                </ion-item>
              </ion-col>
            </ion-row>

            <ion-row
              *ngIf="dSS.dsCode === 'Kal-radimdienst' || dSS.dsCode === 'Kal-Radimdienst'|| dSS.dsCode === 'kal-radimdienst'"
            >
              <ion-col>
                <ion-item lines="inset">
                  <ion-input
                    label="Arbeitgeberanteil"
                    labelPlacement="floating"
                    type="number"
                    [(ngModel)]="dSS.dienststelle.aganteil"
                    (ngModelChange)="berechnen()"
                  >
                  </ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <div class="content-spanner">
              <app-ride-fahrrad></app-ride-fahrrad>
            </div>
            <div class="content-spanner">
              <app-ride-beschaefigungsmerkmale></app-ride-beschaefigungsmerkmale>
            </div>

            <div class="content-spanner">
              <app-ride-leasing-rahmenbedingungen></app-ride-leasing-rahmenbedingungen>
            </div>
            <div class="content-spanner">
              <app-ride-schutz-leistung></app-ride-schutz-leistung>
            </div>
          </ion-grid>
          <ion-row style="padding: 12px 16px">
            <ion-col size="12">
              <div
                class="datenschutz-toggle"
                style="
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  cursor: pointer;
                "
                (click)="dSS.showDiv('datenschutz')"
              >
                <ion-icon
                  name="shield-checkmark-outline"
                  style="font-size: 16px; color: var(--rd-text-secondary)"
                ></ion-icon>
                <span class="small-font" style="font-weight: 600"
                  >Datenschutzhinweis</span
                >
                <ion-icon
                  name="chevron-down-outline"
                  style="font-size: 14px; color: var(--rd-text-secondary)"
                ></ion-icon>
              </div>
              <div
                *ngIf="dSS.currInfo == 'datenschutz'"
                class="datenschutz-box"
                style="
                  margin-top: 8px;
                  padding: 10px 14px;
                  background: var(--rd-bg-surface);
                  border-radius: var(--rd-radius-sm);
                  font-size: 13px;
                  color: var(--rd-text-secondary);
                  line-height: 1.5;
                "
              >
                Ihre eingegebenen Daten werden nicht gespeichert oder für andere
                Zwecke verwendet. Weitere Informationen:
                <a
                  href="https://radimdienst.de/datenschutz.php"
                  style="color: var(--radim-dienst-green); font-weight: 500"
                  >Datenschutzerklärung</a
                >
              </div>
            </ion-col>
          </ion-row>
          <div class="button-row">
            <div class="button-row__primary">
              <ion-button
                expand="block"
                class="btn-primary"
                type="submit"
                (click)="berechnen(true)"
                [disabled]="calculationDisabled"
              >
                Berechnen
              </ion-button>
            </div>
            <div class="button-row__secondary">
              <ion-button
                expand="block"
                class="btn-outline-pink"
                (click)="modus()"
              >
                {{ dSS.modusErweitert ? 'Einfacher' : 'Erweiterter' }} Modus
              </ion-button>
            </div>
            <div class="button-row__secondary">
              <ion-button
                expand="block"
                class="btn-ghost"
                (click)="zuruecksetzen()"
              >
                Zurücksetzen
              </ion-button>
            </div>
          </div>

          <ng-container *ngIf="modusSpezial">
            <div *ngIf="dSS.dienststelle.hasSaving; else noSaving">
              <ion-row style="padding: 8px 0">
                <ion-col size="12">
                  <ion-button
                    expand="block"
                    class="btn-secondary"
                    (click)="createPDF()"
                  >
                    Als PDF herunterladen
                  </ion-button>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <div
                    *ngIf="!isValid"
                    class="alert alert-danger alert-dismissible fade show"
                  >
                    <strong>Fehler!</strong> Bitte füllen Sie alle als
                    Pflichtfeld gekennzeichneten Felder aus. 
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="alert"
                    ></button>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <div class="border-white">
                    <ion-row>
                      <ion-col size="8">
                        <p><b>Gesamtrate vor Entgeltumwandlung</b></p>
                      </ion-col>
                      <ion-col size="4" class="ion-padding-start">
                        <p>
                          <b class="color-green"
                            >{{ euro(zvE - zvE2 + outGwV)| customCurrency }}
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="8">
                        <p><b>Tatsächliche Nettobelastung monatlich</b></p>
                      </ion-col>
                      <ion-col size="4" class="ion-padding-start">
                        <p>
                          <b class="color-green"
                            >{{ monNettoBelastungOhneVorsteuer() |
                            customCurrency }}
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="8">
                        <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                      </ion-col>
                      <ion-col size="4" class="ion-padding-start">
                        <p>
                          <b class="color-green summary-saving-value">
                            <span class="summary-saving-amount"
                              >{{ euro(outErsparnisFix)| customCurrency }}</span
                            >
                            <span class="summary-saving-percent"
                              >= {{ formatNumber(outErsparnisRel) }} %</span
                            >
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </div>
            <ng-template #noSaving>
              <hr />
              <ion-row>
                <ion-col>
                  <div class="border-white">
                    <ion-row>
                      <ion-col size="6">
                        <p><b>monatliche Leasingrate</b></p>
                      </ion-col>
                      <ion-col size="6" class="ion-padding-start">
                        <p>
                          <b
                            >{{ euro((zvE) - (zvE2) + outGwV)| customCurrency }}
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="8">
                        <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                      </ion-col>
                      <ion-col size="4" class="ion-padding-start border-white">
                        <p>
                          <b class="summary-saving-value">
                            <span class="summary-saving-amount"
                              >{{ euro(outGesKostenLZ1) -
                              getNoSavingTotalBikeCost()| customCurrency }}</span
                            >
                            <span class="summary-saving-percent"
                              >= {{
                              formatNumber(100 - getNoSavingTotalBikeCost() * 100
                              / outGesKostenLZ1) }} %</span
                            >
                          </b>
                        </p>
                      </ion-col>
                    </ion-row>
                  </div>
                </ion-col>
              </ion-row>
            </ng-template>
            <ion-row>
              <ion-col size="12">
                <div class="border-white" style="margin-top: 12px">
                  <p
                    style="
                      font-size: 14px;
                      color: #111827;
                      font-style: italic;
                      margin: 0;
                    "
                  >
                    Hinweis: Diese Berechnung ist eine unverbindliche
                    Darstellung der Kostenersparnis.
                  </p>
                </div>
              </ion-col>
            </ion-row>
            <ion-row style="padding: 8px 0 4px 0">
              <ion-col>
                <ion-button
                  expand="block"
                  class="btn-primary"
                  (click)="showDetails()"
                  [disabled]="calculationDisabled"
                >
                  {{ ergebnis ? 'Details ausblenden' : 'Details anzeigen' }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ng-container>
        </div>
      </ion-col>
      <!--rechts -->
      <ion-col *ngIf="ergebnis" size="12" size-lg="6">
        <ng-container>
          <!-- Details-->
          <ion-row
            [ngClass]="'max-w-530x content-spanner border-box bg-light-dark'"
            style="overflow: hidden"
          >
            <ion-grid class="ion-margin-start ion-margin-end ion-margin-bottom">
              <ion-row
                style="
                  background: var(--radim-dienst-green);
                  border-radius: var(--rd-radius-sm);
                  margin-bottom: 4px;
                "
              >
                <ion-col
                  size="5"
                  style="border-right: 1px solid rgba(255, 255, 255, 0.15)"
                >
                  <h2
                    style="
                      color: white;
                      font-size: 0.95rem;
                      margin: 6px 0;
                      font-weight: 700;
                      padding-left: 3px;
                    "
                  >
                    Vergleich
                  </h2>
                </ion-col>
                <ion-col
                  size="3"
                  class="ion-padding-start"
                  style="
                    border-right: 1px solid rgba(255, 255, 255, 0.15);
                    display: flex;
                    align-items: center;
                  "
                >
                  <p
                    style="
                      color: rgba(255, 255, 255, 0.9);
                      font-weight: 600;
                      font-size: 0.8rem;
                      margin: 0;
                    "
                  >
                    <b>Direktkauf</b>
                  </p>
                </ion-col>
                <ion-col
                  size="4"
                  class="ion-padding-start"
                  style="display: flex; align-items: center"
                >
                  <p
                    style="
                      color: rgba(255, 255, 255, 0.9);
                      font-weight: 600;
                      font-size: 0.8rem;
                      margin: 0;
                    "
                  >
                    <b
                      >{{ dSS.dienststelle.hasSaving ? 'Entgeltumwandlung' :
                      'Leasingrate' }}</b
                    >
                  </p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p><b>Bruttomonatsentgelt</b></p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p><b>{{ euro(outBruttoMonat)| customCurrency }}</b></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p><b>{{ euro(outBruttoMonat)| customCurrency }}</b></p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p>Leasingrate</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(outLeasingrate)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="5" class="border-r border-b">
                  <p>{{ getRadFahrSchutzLabel() }}</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>-{{ euro(outVersAN1) | customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="!dSS.isNipDienststelle()">
                <ion-col size="5" class="border-r border-b">
                  <p>RadimDienst Inspektionspaket</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p
                    *ngIf="(inputValue?.toLowerCase() === 'lhr-1125' || dSS.dsCode?.toLowerCase() === 'lhr-1125')"
                  >
                    inklusive
                  </p>
                  <p
                    *ngIf="!(inputValue?.toLowerCase() === 'lhr-1125' || dSS.dsCode?.toLowerCase() === 'lhr-1125')"
                  >
                    - {{ euro(outInspektion)| customCurrency }}
                  </p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="outAGAnteil !== 0">
                <ion-col size="5" class="border-r border-b color-green">
                  <p><b>Fairbetrag</b></p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col
                  size="4"
                  class="border-b ion-padding-start color-green"
                >
                  <p>
                    <b>+ {{ euro(outAGAnteil) | customCurrency }} </b>
                  </p>
                </ion-col>
              </ion-row>
              <ion-row
                *ngIf="dSS.dienststelle.oneProzent == 1 && !dSS.isOneProzentUStArbeitgeber()"
              >
                <ion-col size="5" class="border-r border-b">
                  <p>MwSt. auf 1% des Ausgangsumsatzes</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(outOnePercent)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="outOnePercentAG > 0">
                <ion-col size="5" class="border-r border-b color-green">
                  <p>
                    MwSt. auf 1% des Ausgangsumsatzes
                    <br />
                    <small>(übernimmt der Arbeitgeber)</small>
                  </p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col
                  size="4"
                  class="border-b ion-padding-start color-green"
                >
                  <p>{{ euro(0)| customCurrency }}</p>
                </ion-col>
              </ion-row>

              <ion-row class="color-green">
                <ion-col size="5" class="border-r border-b">
                  <p><b>Gesamtrate</b></p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col size="4" class="border-b ion-padding-start">
                  <p>- {{ euro(zvE - zvE2 + outGwV)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <ion-row *ngIf="dSS.dienststelle.hasSaving">
                <ion-col size="5" class="border-r border-b color-green">
                  <p>Geldwerter Vorteil (gwV)</p>
                </ion-col>
                <ion-col size="3" class="border-r border-b ion-padding-start">
                  <p></p>
                </ion-col>
                <ion-col
                  size="4"
                  class="border-b ion-padding-start color-green"
                >
                  <p>+ {{ euro(outGwV)| customCurrency }}</p>
                </ion-col>
              </ion-row>
              <!-- Ab hier Excel Punkte die nicht im Jobrad-Rechner waren -->
              <ion-row>
                <ion-col class="bg-grau"></ion-col>
              </ion-row>
              <div *ngIf="dSS.dienststelle.hasSaving">
                <ion-row class="color-green">
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Gesamtumwandlungsrate</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(zvE - zvE2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <!-- Ab hier "normale" Steuerberechnung -->
                <ion-row class="color-green">
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Steuer-/SV-pflichtiges Entgelt</b></p>
                  </ion-col>

                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b>{{ euro(zvE)| customCurrency }} </b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ euro(zvE2)| customCurrency }} </b></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Lohnsteuer</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outlSt1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outlSt2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Solidaritätszuschlag</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ 0| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ 0| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Kirchensteuer</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outKiSt1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outKiSt2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Rentenversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outRV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outRV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Krankenversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outKV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outKV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Pflegeversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outPV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outPV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Arbeitslosenversicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outAV1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outAV2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row
                  *ngIf="dSS.dienststelle.oneProzentNetto && dSS.dienststelle.hasSaving && !dSS.isOneProzentUStArbeitgeber()"
                >
                  <ion-col size="5" class="border-r border-b">
                    <p>MwSt. auf 1% des Ausgangsumsatzes</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outOnePercentNetto)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Arbeitnehmeranteil Zusatzversorgung (bspw. VBL)</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>- {{ euro(outVBLbeitrag1)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outVBLbeitrag2)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>abzüglich geldwerter Vorteil</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>- {{ euro(outGwV)| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Nettoentgelt</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>
                      <b>{{ nettoEntgelt1()|customCurrency }}</b>
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b>{{ nettoEntgelt2()| customCurrency }}</b>
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="dSS.kvValue !== 'gkv'">
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Privat Versicherung</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b>{{ euro(outpvsumm)| customCurrency }} </b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ euro(outpvsumm)| customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="dSS.kvValue !=='gkv'">
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Arbeitgeber-Anteil Private Kranken- und
                        Pflegeversicherung</b
                      >
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>
                      <b>{{ euro(outpkvA + dSS.pvAnteil) |customCurrency }}</b>
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b>{{ euro(outpkvA + dSS.pvAnteil) |customCurrency }}</b>
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Auszahlungsbetrag</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>
                      <b>{{ auszahlungsbetrag1()|customCurrency }}</b>
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b>{{ auszahlungsbetrag2() | customCurrency }}</b>
                    </p>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Tats. monatliche Nettobelastung
                        <span *ngIf="ustAgVar === 2"
                          >ohne Vorsteuerabzugsberechtigung</span
                        >
                      </b>
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b
                        >{{ monNettoBelastungOhneVorsteuer()| customCurrency
                        }}</b
                      >
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="ustAgVar === 2 ">
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Tats. monatliche Nettobelastung mit
                        Vorsteuerabzugsberechtigung</b
                      >
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b
                        >{{ monNettoBelastungMitVorsteuer() | customCurrency
                        }}</b
                      >
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Übersicht Kosten des Rades</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="ustAgVar !== 2">
                  <ion-col size="5" class="border-r border-b">
                    <p>Summe Nettobelastung über Leasinglaufzeit</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>{{ sumNettoBelastungTotal()| customCurrency }}</p>
                  </ion-col>
                </ion-row>
                <ng-container *ngIf="ustAgVar === 2 ">
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>
                        Summe Nettobelastung über Leasinglaufzeit ohne
                        Vorsteuerabzugsberechtigung
                      </p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        {{ sumNettoBelastungTotalOhneVorsteuer()|customCurrency
                        }}
                      </p>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>
                        Summe Nettobelastung über Leasinglaufzeit mit
                        Vorsteuerabzugsberechtigung
                      </p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        {{ sumNettoBelastungTotalMitVorsteuer()| customCurrency
                        }}
                      </p>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>Summe Nettobelastung über Leasinglaufzeit Insgesamt</p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>{{ outKaufpreis| customCurrency }}</p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        {{
                        sumNettoBelastungTotalMitPlusOhneVorsteuer()|customCurrency
                        }}
                      </p>
                    </ion-col>
                  </ion-row>
                </ng-container>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Rad-Versicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(getRadVersicherung())| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>inklusive</p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="dSS.dienststelle.inspektion != 0 && !dSS.isNipDienststelle()">
                  <ion-col size="5" class="border-r border-b">
                    <p>Inspektion</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <!--  check for Flex and Basis -->
                    <p>
                      {{ this.euro(this.dSS.dienststelle.sonderInspektion *
                      this.outLeasingduration) |customCurrency }}
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      {{ dSS.dienststelle.inspektion != 0 ? 'Inklusive' : 'Ohne
                      Inspektion' }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b position-relative">
                    <div class="info-label">
                      <b>{{ dSS.isNipDienststelle() ? 'Restwert' : 'Übernahmepreis' }}</b>
                      <ion-icon
                        class="info-icon"
                        name="information-circle-outline"
                        (click)="dSS.toggleInfo('UEBERNAHMEPREIS_INFO')"
                      ></ion-icon>
                    </div>

                    <div *ngIf="dSS.currInfo === 'UEBERNAHMEPREIS_INFO'" class="info-box">
                      <p class="info-text" *ngIf="dSS.isNipDienststelle()">
                        Der Übernahmepreis setzt sich zusammen aus Restwert
                        zzgl. Pauschalbesteuerung.
                      </p>
                      <p class="info-text" *ngIf="!dSS.isNipDienststelle()">
                        Im Übernahmepreis enthalten ist der Restwert des Rades
                        (kalkulatorischer Wert für das Dienstrad der
                        Leasingbank, der nicht über die Leasingraten amortisiert
                        wird), der an die Leasingbank abgeführt wird. Außerdem
                        leistet RadimDienst die Pauschalversteuerung des
                        geldwerten Vorteils durch die vergünstigte Übernahme an
                        das zuständige Betriebsstättenfinanzamt.
                      </p>
                    </div>
                  </ion-col>

                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b></b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ getRestwert() | customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>
                      <b
                        >Gesamtkosten (nach {{ outLeasingduration }} Monaten)</b
                      >
                    </p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b>= {{ euro(outGesKostenLZ1)| customCurrency }}</b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>= {{ euro(outGesKostenLZ2)| customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      <b
                        >{{ euro(outErsparnisFix)| customCurrency }} ={{
                        formatNumber(outErsparnisRel) }} %</b
                      >
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
              </div>
              <div *ngIf="!dSS.dienststelle.hasSaving">
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>Übersicht Kosten des Rades</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p></p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Summe Nettobelastung über Leasinglaufzeit</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(outKaufpreis)| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      {{ euro(outLeasingrate * outLeasingduration)|
                      customCurrency }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p>Rad-Versicherung</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p>{{ euro(getRadVersicherung())| customCurrency }}</p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>inklusive</p>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="!dSS.isNipDienststelle()">
                  <ion-col size="5" class="border-r border-b">
                    <p>Inspektion</p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <!--  check for Flex and Basis -->
                    <p>
                      {{ this.euro(this.dSS.dienststelle.sonderInspektion *
                      this.outLeasingduration) |customCurrency }}
                    </p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p>
                      {{ dSS.dienststelle.inspektion != 0 ? 'Inklusive' : 'Ohne
                      Inspektion' }}
                    </p>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="5" class="border-r border-b">
                    <p><b>{{ dSS.isNipDienststelle() ? 'Restwert' : 'Übernahmepreis' }}</b></p>
                  </ion-col>
                  <ion-col size="3" class="border-r border-b ion-padding-start">
                    <p><b></b></p>
                  </ion-col>
                  <ion-col size="4" class="border-b ion-padding-start">
                    <p><b>{{ getRestwert() | customCurrency }}</b></p>
                  </ion-col>
                </ion-row>
                <div
                  *ngIf=" euro(outGesKostenLZ1) >= getNoSavingTotalBikeCost()"
                >
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p>
                        <b
                          >Gesamtkosten (nach {{ outLeasingduration }}
                          Monaten)</b
                        >
                      </p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p>
                        <b>= {{ euro(outGesKostenLZ1)| customCurrency }}</b>
                      </p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        <b
                          >= {{ getNoSavingTotalBikeCost()| customCurrency }}</b
                        >
                      </p>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="5" class="border-r border-b">
                      <p><b>Ersparnis ggü. dem Direktkauf</b></p>
                    </ion-col>
                    <ion-col
                      size="3"
                      class="border-r border-b ion-padding-start"
                    >
                      <p></p>
                    </ion-col>
                    <ion-col size="4" class="border-b ion-padding-start">
                      <p>
                        <b
                          >{{ euro(outGesKostenLZ1) -
                          getNoSavingTotalBikeCost()| customCurrency }} = {{
                          formatNumber(100 - getNoSavingTotalBikeCost() * 100 /
                          outGesKostenLZ1) }} %</b
                        >
                      </p>
                    </ion-col>
                  </ion-row>
                </div>
                <ion-row>
                  <ion-col class="bg-grau"></ion-col>
                </ion-row>
              </div>
              <ion-row>
                <ion-col class="ion-margin-start" style="padding-top: 12px">
                  <p
                    style="
                      font-size: 14px;
                      color: #111827;
                      font-style: italic;
                      background: var(--rd-bg-surface);
                      padding: 10px 14px;
                      border-radius: var(--rd-radius-sm);
                      border-left: 3px solid var(--rd-border-medium);
                    "
                  >
                    Hinweis: Diese Berechnung ist eine unverbindliche
                    Darstellung der Kostenersparnis.
                  </p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-row>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<!-- use xy-Koordinatensysten to check if calculater works fine

<button (click)="startDiagram()" class="btn btn-secondary">Start</button>
<canvas #chartCanvas width="400" height="auto"></canvas>

-->
